import { Button } from "primereact/button";
import { formatBytes, getFileIcon } from "../helpers/fileHelpers";
import { formatDate } from "../helpers/dateTimeHelper";
import { DATETIME_FORMATS } from "../constants/datetime-formats";
import { downloadFile } from "../services/fileService";
const FileDownloader = ({ file }) => {
  const handleDownloadFile = async () => {
    try {
      const response = await downloadFile({
          url: file.path,
          fileName: file.name
        });

      if (!response.ok) {
        return;
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = file.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
        return;
    }
  };

  return (
    <div className="keduall-file-downloader flex align-items-center justify-content-between p-3 gap-3">
      <div className="w-auto">
        <img src={getFileIcon(file.contentType)} alt="icon" />
      </div>
      <div className="flex-1">
        <div className="keduall-typography text-14-medium-500">
          {file.name}
        </div>
        <div className="keduall-typography text-12-normal-400">
          {formatBytes(file.size)} . {formatDate(file.createdTime, DATETIME_FORMATS.DDMMMYYYY)}
        </div>
      </div>
      <div className="w-auto">
        <Button icon="pi pi-download" className="text-default-txt-color" rounded text aria-label="Download" onClick={handleDownloadFile} />
      </div>
    </div>
  );
}

export default FileDownloader;